(function () {
  function initDisposeYourPanty(section) {
    if (!section || section.dataset.disposeInitialized === 'true') {
      return;
    }

    section.dataset.disposeInitialized = 'true';

    const openButton = section.querySelector(
      '[data-dispose-popup-open]'
    );

    const popup = section.querySelector(
      '[data-dispose-popup]'
    );

    /*
      ============================================================
      POPUP
      ============================================================
    */

    if (openButton && popup) {
      const closeButtons = popup.querySelectorAll(
        '[data-dispose-popup-close]'
      );

      let lastFocusedElement = null;
      const popupOriginalParent = popup.parentElement;
      const popupOriginalNextSibling = popup.nextSibling;

      /*
        Keep the popup on body so position:fixed
        always covers the full viewport and is not
        clipped by section overflow/transforms.
      */
      document.body.appendChild(popup);

      function openPopup() {
        lastFocusedElement = document.activeElement;

        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');

        document.body.classList.add('dispose-popup-open');

        const closeButton = popup.querySelector(
          '.dispose-your-panty__popup-close'
        );

        if (closeButton) {
          closeButton.focus();
        }
      }

      function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');

        document.body.classList.remove(
          'dispose-popup-open'
        );

        if (
          lastFocusedElement &&
          typeof lastFocusedElement.focus === 'function'
        ) {
          lastFocusedElement.focus();
        }
      }

      openButton.addEventListener('click', openPopup);

      closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener(
          'click',
          closePopup
        );
      });

      document.addEventListener(
        'keydown',
        function (event) {
          if (
            event.key === 'Escape' &&
            popup.classList.contains('is-open')
          ) {
            closePopup();
          }
        }
      );

      section._disposePopupCleanup = function () {
        closePopup();

        if (
          popupOriginalParent &&
          popup.parentElement === document.body
        ) {
          if (popupOriginalNextSibling) {
            popupOriginalParent.insertBefore(
              popup,
              popupOriginalNextSibling
            );
          } else {
            popupOriginalParent.appendChild(popup);
          }
        }
      };
    }

    /*
      ============================================================
      MOBILE SLIDER
      ============================================================
    */

    const slider = section.querySelector(
      '.dispose-your-panty__blocks'
    );

    if (!slider) {
      return;
    }

    const slides = Array.from(
      slider.querySelectorAll(
        '.dispose-your-panty__block'
      )
    );

    if (!slides.length) {
      return;
    }

    function isMobile() {
      return window.matchMedia(
        '(max-width: 749px)'
      ).matches;
    }

    /*
      ============================================================
      RESPONSIVE FLEX BASIS
      ============================================================

      Calculate the active slide width from the actual
      slider width instead of using a fixed 64vw.

      This makes the slider responsive on different
      mobile screen sizes.
    */

    function getActiveFlexBasis() {
      const sliderWidth = slider.getBoundingClientRect().width;

      if (!sliderWidth) {
        return 0;
      }

      /*
        Active slide = 70% of viewport width.

        Calculate it from the actual viewport width so
        it remains responsive.
      */

      const viewportWidth = window.innerWidth;

      return Math.round(
        viewportWidth * 0.70
      );
    }

    /*
      ============================================================
      SET RESPONSIVE FLEX BASIS
      ============================================================
    */

    function updateFlexBasis() {
      if (!isMobile()) {
        slides.forEach(function (slide) {
          slide.style.flexBasis = '';
          slide.style.height = '';
        });

        slider.style.height = '';

        return;
      }

      const activeFlexBasis = getActiveFlexBasis();

      slides.forEach(function (slide) {
        if (slide.classList.contains('is-active')) {
          slide.style.flexBasis =
            activeFlexBasis + 'px';
        } else {
          slide.style.flexBasis = '30px';
        }
      });
    }

    /*
      ============================================================
      IMAGE ASPECT HEIGHT
      ============================================================

      Height is calculated from the active slide image
      natural aspect ratio at the active slide width.
    */

    function getImageAspectRatio(image) {
      if (!image) {
        return 0;
      }

      if (
        image.naturalWidth > 0 &&
        image.naturalHeight > 0
      ) {
        return (
          image.naturalHeight /
          image.naturalWidth
        );
      }

      const attrWidth = parseFloat(
        image.getAttribute('width')
      );
      const attrHeight = parseFloat(
        image.getAttribute('height')
      );

      if (
        attrWidth > 0 &&
        attrHeight > 0
      ) {
        return attrHeight / attrWidth;
      }

      return 0;
    }

    function getActiveSlideHeight() {
      const activeSlide =
        slider.querySelector(
          '.dispose-your-panty__block.is-active'
        ) || slides[0];

      if (!activeSlide) {
        return 0;
      }

      const image = activeSlide.querySelector(
        '.dispose-your-panty__image'
      );

      const aspectRatio =
        getImageAspectRatio(image);

      if (!aspectRatio) {
        return 0;
      }

      const activeWidth =
        getActiveFlexBasis() ||
        activeSlide.getBoundingClientRect()
          .width;

      if (!activeWidth) {
        return 0;
      }

      return Math.round(
        activeWidth * aspectRatio
      );
    }

    function applySliderHeight(height) {
      if (!(height > 0)) {
        return;
      }

      slider.style.height = height + 'px';

      slides.forEach(function (slide) {
        slide.style.height = height + 'px';
      });
    }

    /*
      ============================================================
      LOCK HEIGHT
      ============================================================
    */

    function lockSliderHeight() {
      if (!isMobile()) {
        slider.style.height = '';

        slides.forEach(function (slide) {
          slide.style.height = '';
        });

        return;
      }

      updateFlexBasis();

      requestAnimationFrame(function () {
        applySliderHeight(
          getActiveSlideHeight()
        );
      });
    }

    function whenImagesReady(callback) {
      const images = slides
        .map(function (slide) {
          return slide.querySelector(
            '.dispose-your-panty__image'
          );
        })
        .filter(Boolean);

      if (!images.length) {
        callback();
        return;
      }

      let remaining = images.length;

      function onReady() {
        remaining -= 1;

        if (remaining <= 0) {
          callback();
        }
      }

      images.forEach(function (image) {
        if (image.complete) {
          onReady();
          return;
        }

        image.addEventListener(
          'load',
          onReady,
          { once: true }
        );

        image.addEventListener(
          'error',
          onReady,
          { once: true }
        );
      });
    }

    /*
      ============================================================
      ACTIVE SLIDE
      ============================================================
    */

    function setActiveSlide(
      index,
      shouldScroll = true
    ) {
      if (!isMobile()) {
        return;
      }

      if (index < 0) {
        index = 0;
      }

      if (index >= slides.length) {
        index = slides.length - 1;
      }

      /*
        Keep the current height locked while the
        horizontal flex-basis transition happens.
      */

      const currentHeight =
        slider.getBoundingClientRect().height;

      if (currentHeight > 0) {
        applySliderHeight(currentHeight);
      }

      slides.forEach(function (
        slide,
        slideIndex
      ) {
        slide.classList.toggle(
          'is-active',
          slideIndex === index
        );
      });

      updateFlexBasis();

      if (shouldScroll) {
        const slide = slides[index];

        slider.scrollTo({
          left:
            slide.offsetLeft -
            slider.offsetLeft,
          behavior: 'smooth'
        });
      }

      /*
        Recalculate height from the newly
        active image aspect ratio.
      */

      requestAnimationFrame(function () {
        lockSliderHeight();
      });
    }

    /*
      ============================================================
      CLICK ON ANY SLIDE
      ============================================================

      Mobile only:
      - Click active slide → advance to the next slide
      - Click another slide → open that slide
    */

    slides.forEach(function (
      slide,
      index
    ) {
      slide.addEventListener(
        'click',
        function () {
          if (!isMobile()) {
            return;
          }

          if (
            slide.classList.contains(
              'is-active'
            )
          ) {
            const nextIndex =
              (index + 1) %
              slides.length;

            setActiveSlide(nextIndex);
            return;
          }

          setActiveSlide(index);
        }
      );
    });

    /*
      ============================================================
      DETECT SLIDE AFTER SWIPE / SCROLL
      ============================================================
    */

    let scrollTimer;

    slider.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) {
          return;
        }

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(
          function () {
            const scrollLeft =
              slider.scrollLeft;

            let closestIndex = 0;
            let closestDistance =
              Infinity;

            slides.forEach(
              function (
                slide,
                index
              ) {
                const distance =
                  Math.abs(
                    slide.offsetLeft -
                    slider.offsetLeft -
                    scrollLeft
                  );

                if (
                  distance <
                  closestDistance
                ) {
                  closestDistance =
                    distance;

                  closestIndex =
                    index;
                }
              }
            );

            /*
              Keep the current height locked
              while changing active slide.
            */

            const currentHeight =
              slider.getBoundingClientRect()
                .height;

            if (currentHeight > 0) {
              applySliderHeight(currentHeight);
            }

            slides.forEach(
              function (
                slide,
                index
              ) {
                slide.classList.toggle(
                  'is-active',
                  index ===
                    closestIndex
                );
              }
            );

            /*
              Update flex sizes for the
              newly active slide.
            */

            updateFlexBasis();

            requestAnimationFrame(
              function () {
                lockSliderHeight();
              }
            );
          },
          80
        );
      },
      {
        passive: true
      }
    );

    /*
      ============================================================
      FIRST SLIDE ACTIVE BY DEFAULT
      ============================================================
    */

    slides.forEach(function (
      slide,
      index
    ) {
      slide.classList.toggle(
        'is-active',
        index === 0
      );
    });

    /*
      Set responsive flex sizes first.
    */

    updateFlexBasis();

    /*
      Lock initial height from image aspect
      ratio once images are ready.
    */

    whenImagesReady(function () {
      requestAnimationFrame(function () {
        lockSliderHeight();
      });
    });

    /*
      ============================================================
      RESPONSIVE RESIZE
      ============================================================
    */

    let resizeTimer;

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {
            if (isMobile()) {
              /*
                Get active slide.
              */

              const activeSlide =
                slider.querySelector(
                  '.dispose-your-panty__block.is-active'
                );

              /*
                Update flex-basis according
                to the new screen width.
              */

              updateFlexBasis();

              /*
                Recalculate height.
              */

              lockSliderHeight();

              /*
                Keep active slide in position.
              */

              if (activeSlide) {
                requestAnimationFrame(
                  function () {
                    slider.scrollTo({
                      left:
                        activeSlide.offsetLeft -
                        slider.offsetLeft,
                      behavior:
                        'auto'
                    });
                  }
                );
              }
            } else {
              /*
                Desktop:
                remove mobile inline styles.
              */

              slides.forEach(
                function (slide) {
                  slide.classList.remove(
                    'is-active'
                  );

                  slide.style.flexBasis =
                    '';

                  slide.style.height =
                    '';
                }
              );

              slider.style.height =
                '';
            }
          },
          100
        );
      }
    );
  }

  /*
    ============================================================
    INITIALIZE ALL SECTIONS
    ============================================================
  */

  function initAllDisposeYourPanty() {
    document
      .querySelectorAll(
        '.dispose-your-panty'
      )
      .forEach(function (section) {
        initDisposeYourPanty(section);
      });
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAllDisposeYourPanty
    );
  } else {
    initAllDisposeYourPanty();
  }

  /*
    ============================================================
    SHOPIFY THEME EDITOR SUPPORT
    ============================================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section =
        event.target.querySelector(
          '.dispose-your-panty'
        );

      if (section) {
        initDisposeYourPanty(section);
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      const section =
        event.target.querySelector(
          '.dispose-your-panty'
        );

      if (section) {
        if (
          typeof section._disposePopupCleanup ===
          'function'
        ) {
          section._disposePopupCleanup();
        }

        section.dataset.disposeInitialized =
          'false';
      }

      document.body.classList.remove(
        'dispose-popup-open'
      );
    }
  );
})();